import { lazy } from "react";
import { Dashboard, Description} from "@mui/icons-material";
import RouteName from "./Route.name";
import Constants from "../config/constants";


const  DoctorDashboard = lazy(()=>import ("../views/DoctorDashboard/DoctorDashboard.view"));
const  UserAgreement = lazy(()=>import ("../views/UserAgreement/UserAgreement.view"));
const  PatientDetail = lazy(()=>import ("../views/PatientInfo/PatientDetail"));
const  VitalsDetail = lazy(()=>import ("../views/Vitals/VitalsDetail/VitalsDetail.view"));


const dashboardRoutes = [
  {
    path: `${RouteName.PATIENT_DETAIL}:id`,
    sidebarName: "Profile",
    icon: Description,
    component: PatientDetail,
    is_sidebar: false,
    parentRoute: `${RouteName.DOCTOR_DASHBOARD}`,
  },
  {
    path: `${RouteName.VITALS_INFO}:id`,
    sidebarName: "Profile",
    icon: Description,
    component: VitalsDetail,
    is_sidebar: false,
    parentRoute: `${RouteName.DOCTOR_DASHBOARD}`,
  },
  // {
  //   path: `${RouteName.STYLE_GUIDE}`,
  //   sidebarName: "Style Guide",
  //   // icon: FormatShapes,
  //   component: StyleGuide,
  //   is_sidebar: false,
  //   is_protect: false,

  // },
  {
    path: `${RouteName.USER_AGGREEMENT}`,
    component: UserAgreement,
    is_sidebar: false,
    is_protect: false,
  },
  {
    path: RouteName.DOCTOR_DASHBOARD,
    sidebarName: "HCP Dashboard",
    icon: Dashboard,
    component: DoctorDashboard,
    is_sidebar: true,
    module: Constants.MODULES.DOCTOR_PERFORMANCE,
    permissions: ["read"],
    // parent: "admin_dashboards",
  },
];

export default dashboardRoutes;
